<div id="google-login-button" (click)="googleAuthenticate()">
    <span class="icon"></span>
    <span class="gbutton-text">Connect with Google </span>
</div>